import React, { createContext, useReducer, useContext, useCallback } from 'react';
import { initiateBulkCVConversion } from '../services/JSONService';
import { UIContext } from './UIContext';

const initialState = {
  conversionStatus: null,
  currentConversion: null,
  error: null,
  history: []
};

const cvReducer = (state, action) => {
  switch (action.type) {
    case 'CONVERSION_START':
      return {
        ...state,
        conversionStatus: 'loading',
        error: null
      };
    case 'CONVERSION_SUCCESS':
      return {
        ...state,
        conversionStatus: 'success',
        currentConversion: action.payload,
        history: [...state.history, action.payload],
        error: null
      };
    case 'CONVERSION_ERROR':
      return {
        ...state,
        conversionStatus: 'error',
        error: action.payload
      };
    default:
      return state;
  }
};

export const CVContext = createContext(initialState);

export const CVProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cvReducer, initialState);
  const { showAlert } = useContext(UIContext);

  const startConversion = useCallback(async (files, options) => {
    dispatch({ type: 'CONVERSION_START' });
    try {
      const result = await initiateBulkCVConversion(files, options);
      dispatch({ type: 'CONVERSION_SUCCESS', payload: result });
      return result;
    } catch (error) {
      dispatch({ type: 'CONVERSION_ERROR', payload: error.message });
      showAlert(error.message, 'error');
      throw error;
    }
  }, [showAlert]);

  const value = {
    ...state,
    startConversion
  };

  return <CVContext.Provider value={value}>{children}</CVContext.Provider>;
};

export const useCV = () => useContext(CVContext);
